var map = {
	"./1.mp4": 4276,
	"./10.mp4": 3182,
	"./2.mp4": 6283,
	"./3.mp4": 4694,
	"./4.mp4": 3493,
	"./5.mp4": 3904,
	"./6.mp4": 8551,
	"./8.mp4": 1777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5004;